import React from 'react';

import { Hit } from '@algolia/client-search';
import { FiArrowRight } from 'react-icons/fi';

import Service from 'interfaces/Service';

import {
  Container,
  Ribbon,
  ResultInfo,
  CategoryImages,
  ArrowContainer,
} from './styles';

interface ResultProps {
  result: Hit<Service>;
  onResultClick: (result: Hit<Service>) => void;
}

const Result: React.FC<ResultProps> = ({ result, onResultClick }) => {
  return (
    <Container
      key={result.objectID}
      onClick={() => onResultClick(result)}
      hasContactInfo={result.cellphones.length > 0}
    >
      {result.numReviews > 0 && (
        <Ribbon>
          <span>
            {result.numReviews === 1
              ? `1 Indicação`
              : `${result.numReviews} Indicações`}
          </span>
        </Ribbon>
      )}
      <ResultInfo>
        <CategoryImages>
          {result.categories.map((category) => (
            <img
              key={category.id}
              src={`https://firebasestorage.googleapis.com/v0/b/mycircle-app.appspot.com/o/category-icons%2Fwhite%2F${category.id}.png?alt=media&token=f3945487-13da-4e9e-aa0e-cda148d89baa`}
              alt={category.readableName}
              loading="lazy"
              width={50}
            />
          ))}
        </CategoryImages>
        <div>
          <h3>{result.name}</h3>
          <p>
            {result.categories.map((category, i) =>
              i === result.categories.length - 1
                ? `${category.readableName}`
                : `${category.readableName} / `,
            )}
          </p>
        </div>
      </ResultInfo>
      <ArrowContainer>
        <FiArrowRight size={40} color="#FB4570" />
      </ArrowContainer>
    </Container>
  );
};

export default Result;
